import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/button/ActionButton';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { ImageEyeIcon } from 'assets/materialIcons/materialIcons';
import { Link } from 'react-router-dom';

const ShowButton = (props) => {
    const {
        disabled,
        label,
        linkStyle,
        style,
        translate,
        url,
    } = props;

    const defaultLinkStyle = {
        textDecoration: 'none',
        display: 'inline-flex',
    };

    const elLinkStyle = Object.assign({}, defaultLinkStyle, linkStyle, style);

    return (
        <Link to={ url } style={ elLinkStyle }>
            <Button
                disabled={ disabled }
                icon={ <ImageEyeIcon style={ { color: theme.palette.primary1Color } } /> }
                title={ label || translate('actions.show') }
            />
        </Link>
    );
};

ShowButton.defaultProps = {
    url: '',
};

ShowButton.propTypes = {
    disabled: PropTypes.bool,
    label: PropTypes.string,
    linkStyle: PropTypes.object,
    style: PropTypes.object,
    translate: PropTypes.func.isRequired,
    url: PropTypes.string,
};

export default translate(ShowButton);



// WEBPACK FOOTER //
// ./src/components/button/ShowButton.js